import React, { useEffect, useRef, useState } from "react";
import "../../css/DashBoard.css";
import RichBox from "./smallComponents/RichBoxComponent";
import { ReactPainter } from "react-painter";
import { handleCount } from "../../helpers/validation";
import {
  MapSecondsToTime,
  base64ToBlob,
  handleFileUpload2s3,
  imageUrlToBase64,
  makeId,
  requestWithAxios,
} from "../../helpers/func";
import Swal from "sweetalert2";
import DifficultLevel from "./smallComponents/DifficultLevel";
import { BASE_URL } from "../../variables/api";
import axios from "axios";
import LearningStandards from "./smallComponents/LearningStandards";

import { useSelector } from "react-redux";

// editingMode
// examMode
// gradingModeTeacher
// gradingModeStudent

const ImageHighlight = (props: any) => {
  const [state, setState] = useState<any>({
    id: makeId(10),
    type: "ImageHighlight",
    show_objectives: false,
    objectives: "",
    feedback: "",
    mode: "",
    total_mark: "",
    score: "",
    author_note: "",
    header: "",
    qst_image: "",
    resetCanvas: 0,
    calibration: "",
    qst_image_after_drawing: "",
    msg: "",
    headertxt: "",
    required: true,
    difficult: "Basic Level",
    cognitive: "Remembering",
    difficult_id: "",
    cognitive_id: "",
    // this flag is used to see if we have to resave the img
    hasChangedImgFlag: false,
  });

  let count = useRef<any>();
  const [spenttime, setSpentTime] = useState(0);
  const [intervalId, setIntervalId] = useState<any>(null);
  const deviceWidth = window.innerWidth;
  const user = useSelector((storeState: any) => storeState.user);
  useEffect(() => {
    if (props.quest != undefined) {
      let Question = { ...props.quest };
      if (Question.mode == "examMode") {
        axios
          .get(
            `${BASE_URL}/student/getspenttime.php?studentexamquestion_id=${Question.id}`
          )
          .then((response) => {
            setSpentTime(response.data.data);
            const intervalId = setInterval(() => {
              setSpentTime((prev: any) => ++prev);
              // props.onSaveQuestion({ ...state })
            }, 1000);
            setIntervalId(intervalId);
          })
          .catch((err) => {
            setSpentTime(0);
            const intervalId = setInterval(() => {
              setSpentTime((prev: any) => ++prev);
              // props.onSaveQuestion({ ...state })
            }, 1000);
            setIntervalId(intervalId);
          });
      }

      let cal_array: any = [];
      let calibrationObject = Question.calibration;
      if (Question.mode == "editingMode") {
        //Editing mode
        if (typeof Question.calibration == "string") {
          try {
            calibrationObject = JSON.parse(Question.calibration);
          } catch (error) {
            calibrationObject = Question.calibration;
          }
        }
        if (
          Question.calibration !== undefined &&
          Question.calibration !== null &&
          Question.calibration !== "" &&
          Question.rubricsmode != "Holistic"
        ) {
          let Analytical = calibrationObject?.Analytical ?? calibrationObject;
          let splitted_calibration = Analytical?.split(",,");
          splitted_calibration.forEach((cal: any) => {
            // Regular expressions to extract numbers
            var scoreRegex = /\b\d+\b/;
            var testRegex = /if the student's answer\s(.+)/;
            // Extracting the numbers
            var scoreMatch = cal.match(scoreRegex);
            var testMatch = cal.match(testRegex);
            // Converting matches to integers
            var total = scoreMatch ? parseInt(scoreMatch[0]) : null;
            var text = testMatch ? testMatch[1] : null;
            if (total != null && text != null) {
              let cal_obj = { total: total, text: text };
              cal_array.push(cal_obj);
            }
          });
        } else {
          if (
            props.etype == "capstone" &&
            Question.rubricsmode == "Analytical"
          ) {
            for (let index = 4; index > 0; index--) {
              if (index == 1) continue;
              cal_array.push({ total: index, text: "" });
            }
          }
        }
        setState({
          ...Question,
          calibrationArray: [...cal_array],
          calibration: calibrationObject,
        });

        Swal.close();
      }

      Swal.showLoading();
      if (Question.qst_image?.includes("https")) {
        Swal.showLoading();
        if (Question.qst_image?.includes(".txt")) {
          fetch(Question.qst_image)
            .then((res: any) => {
              Swal.showLoading();
              res
                .text()
                .then((data: any) => {
                  Question.qst_image = data;
                  if (
                    Question.qst_image_after_drawing?.includes("https") &&
                    Question.qst_image_after_drawing?.includes(".txt")
                  ) {
                    fetch(Question.qst_image_after_drawing)
                      .then((res: any) => {
                        Swal.showLoading();
                        res.text().then((data: any) => {
                          Question.qst_image_after_drawing = data;
                          if (Question.mode == "editingMode") {
                            setState({
                              ...Question,
                              calibrationArray: [...cal_array],
                              calibration: calibrationObject,
                            });
                          } else {
                            setState(Question);
                          }
                          Swal.close();
                        });
                      })
                      .catch((err: any) => {
                        Swal.fire({
                          icon: "error",
                          text: "Image will not appear if you have problem with internet connection",
                        });
                        if (Question.mode == "editingMode") {
                          setState({
                            ...Question,
                            calibrationArray: [...cal_array],
                            calibration: calibrationObject,
                          });
                        } else {
                          setState(Question);
                        }
                      });
                  } else if (
                    Question.qst_image_after_drawing?.includes("https")
                  ) {
                    imageUrlToBase64(Question.qst_image_after_drawing)
                      .then((res: any) => {
                        Question.qst_image_after_drawing = res;
                        if (Question.mode == "editingMode") {
                          setState({
                            ...Question,
                            calibrationArray: [...cal_array],
                            calibration: calibrationObject,
                          });
                        } else {
                          setState(Question);
                        }

                        Swal.close();
                      })
                      .catch((err: any) => {
                        Swal.fire({
                          icon: "error",
                          text: "Image will not appear if you have problem with internet connection",
                        });
                        if (Question.mode == "editingMode") {
                          setState({
                            ...Question,
                            calibrationArray: [...cal_array],
                            calibration: calibrationObject,
                          });
                        } else {
                          setState(Question);
                        }
                      });
                  } else {
                    if (Question.mode == "editingMode") {
                      setState({
                        ...Question,
                        calibrationArray: [...cal_array],
                        calibration: calibrationObject,
                      });
                    } else {
                      setState(Question);
                    }
                  }

                  Swal.close();
                })
                .catch((err: any) => {
                  Swal.fire({
                    icon: "error",
                    text: "Image will not appear if you have problem with internet connection",
                  });
                });
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                text: "Image will not appear if you have problem with internet connection",
              });
              if (Question.mode == "editingMode") {
                setState({
                  ...Question,
                  calibrationArray: [...cal_array],
                  calibration: calibrationObject,
                });
              } else {
                setState(Question);
              }
            });
        } else {
          imageUrlToBase64(Question.qst_image)
            .then((res: any) => {
              Question.qst_image = res;

              if (Question.qst_image_after_drawing?.includes("https")) {
                imageUrlToBase64(Question.qst_image_after_drawing)
                  .then((res: any) => {
                    Question.qst_image_after_drawing = res;
                    if (Question.mode == "editingMode") {
                      setState({
                        ...Question,
                        calibrationArray: [...cal_array],
                        calibration: calibrationObject,
                      });
                    } else {
                      setState(Question);
                    }

                    Swal.close();
                  })
                  .catch((err: any) => {
                    Swal.fire({
                      icon: "error",
                      text: "Image will not appear if you have problem with internet connection",
                    });
                    if (Question.mode == "editingMode") {
                      setState({
                        ...Question,
                        calibrationArray: [...cal_array],
                        calibration: calibrationObject,
                      });
                    } else {
                      setState(Question);
                    }
                  });
                Swal.close();
              } else {
                if (Question.mode == "editingMode") {
                  setState({
                    ...Question,
                    calibrationArray: [...cal_array],
                    calibration: calibrationObject,
                  });
                } else {
                  setState(Question);
                }

                Swal.close();
              }
            })
            .catch((err: any) => {
              Swal.fire({
                icon: "error",
                text: "Image will not appear if you have problem with internet connection",
              });
              if (Question.mode == "editingMode") {
                setState({
                  ...Question,
                  calibrationArray: [...cal_array],
                  calibration: calibrationObject,
                });
              } else {
                setState(Question);
              }
            });
        }
      } else {
        if (Question.mode == "editingMode") {
          setState({
            ...Question,
            calibrationArray: [...cal_array],
            calibration: calibrationObject,
          });
        } else {
          setState(Question);
        }

        Swal.close();
      }
    } else {
      let cal_array: any = [];
      let total_mark = 0;
      if (
        state.calibration !== undefined &&
        state.calibration !== null &&
        state.calibration !== ""
      ) {
        let splitted_calibration = state.calibration?.Analytical?.split(",,");
        splitted_calibration.forEach((cal: any) => {
          // Regular expressions to extract numbers
          var scoreRegex = /\b\d+\b/;
          var testRegex = /if the student's answer\s(.+)/;
          // Extracting the numbers
          var scoreMatch = cal.match(scoreRegex);
          var testMatch = cal.match(testRegex);
          // Converting matches to integers
          var total = scoreMatch ? parseInt(scoreMatch[0]) : null;
          var text = testMatch ? testMatch[1] : null;
          if (total != null && text != null) {
            let cal_obj = { total: total, text: text };
            cal_array.push(cal_obj);
          }
        });
      } else {
        if (props.etype == "capstone") {
          total_mark = 4;
          for (let index = 4; index > 0; index--) {
            if (index == 1) continue;
            cal_array.push({ total: index, text: "" });
          }
        }
      }
      setState((prev: any) => ({
        ...prev,
        calibrationArray: [...cal_array],
        total_mark: total_mark,
        mode: "editingMode",
        all_targets: props.course_standards_targets,
      }));

      Swal.close();
    }
  }, []);

  useEffect(() => {
    return () => {
      if (
        state.mode == "examMode" &&
        state.studentexam_id !== undefined &&
        state.studentexam_id != null
      ) {
        clearInterval(intervalId);
        requestWithAxios(BASE_URL + "student/savespenttime.php", {
          spenttime: count?.current?.value,
          studentexamquestion_id: state.id,
        });
      }
    };
  }, [intervalId]);

  let colors = ["blue", "green", "yellow"];

  const onSaveQuestion = (updatedState: any) => {
    let require = handleCount(state.header);

    if (require) {
      Swal.fire({
        icon: "error",
        text: " Question Header is required",
      }).then(() => {});
    } else if (state.qst_image == "") {
      Swal.fire({
        icon: "error",
        text: " You have to upload image",
      }).then(() => {});
    } else if (state.total_mark.length == 0 || state.total_mark == ".") {
      Swal.fire({
        icon: "error",
        text: "Total mark is required",
      }).then(() => {});
    }
    // else if (
    //   props?.coursestandards?.length > 0 &&
    //   !updatedState?.standardid
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     text: "this course has learning standards available , please choose at least one for this question ",
    //   }).then(() => {});
    // }
    // else if (!updatedState.difficult_id && !user.isExternalUser) {
    //   Swal.fire({
    //     icon: "error",
    //     text: "Please select the difficult level",
    //   }).then(() => {});
    // } else if (!updatedState.cognitive_id && !user.isExternalUser) {
    //   Swal.fire({
    //     icon: "error",
    //     text: "Please select the Cognitive level",
    //   }).then(() => {});
    // }
    // else if (
    //   updatedState?.all_targets?.length > 0 &&
    //   !updatedState?.learning_targets
    // ) {
    //   Swal.fire({
    //     icon: "error",
    //     text: " this standard has learning targets available , please choose at least one for this question ",
    //   }).then(() => {});
    // }
    else {
      if (updatedState.mode == "editingMode") {
        let calibration = "";
        if (
          updatedState.calibrationArray?.length > 0 &&
          updatedState.calibration?.Holistic
        ) {
          updatedState.rubricsmode = "Both";
          for (let index = updatedState.total_mark; index > 0; index--) {
            if (props.etype == "capstone" && index == 1) continue;

            let calibration_text =
              updatedState.calibrationArray.find(
                (cal: any) => cal.total == index
              )?.text ?? "";
            calibration_text = calibration_text.replace(/,,/g, ",");
            calibration +=
              "set the score to " +
              index +
              " if the student's answer " +
              calibration_text +
              " ,, ";
          }
          if (props.etype == "capstone") {
            calibration += " else set score to 1";
          } else {
            calibration += " else set score to 0";
          }
          updatedState.calibration.Analytical = calibration;
        } else if (
          updatedState.calibrationArray?.length == 0 &&
          updatedState.calibration?.Holistic
        ) {
          updatedState.rubricsmode = "Holistic";
          updatedState.calibration.Analytical = calibration;
        } else {
          updatedState.rubricsmode = "Analytical";
          for (let index = updatedState.total_mark; index > 0; index--) {
            if (props.etype == "capstone" && index == 1) continue;

            let calibration_text =
              updatedState.calibrationArray.find(
                (cal: any) => cal.total == index
              )?.text ?? "";
            calibration_text = calibration_text.replace(/,,/g, ",");
            calibration +=
              "set the score to " +
              index +
              " if the student's answer " +
              calibration_text +
              " ,, ";
          }
          if (props.etype == "capstone") {
            calibration += " else set score to 1";
          } else {
            calibration += " else set score to 0";
          }
          let calibrationObj = {
            Analytical: calibration,
            Holistic: "",
          };
          updatedState.calibration = calibrationObj;
        }
      }

      // if (state.mode == "editingMode")
      if (state.hasChangedImgFlag) {
        const imageBlob = base64ToBlob(state.qst_image, "image/png");
        var formData = new FormData();
        formData.append("file", imageBlob, "imagehighlight.png");
        Swal.showLoading();
        handleFileUpload2s3(formData.get("file"), state.id)
          .then((res: any) => {
            let tempUpdatedState = {
              ...updatedState,
              qst_image: res,
              hasChangedImgFlag: false,
            };
            props.onSaveQuestion(tempUpdatedState);
            Swal.close();
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              text: "Image was not saved, please check your internet connection",
            });
          });
      } else {
        props.onSaveQuestion(updatedState);
      }
    }
  };

  // setHeader = (contents: any) => {
  //   header = contents;
  // };
  const resetcanvasfunc = () => {
    setState((prev: any) => ({
      ...prev,
      resetCanvas: Math.random(),
      qst_image_after_drawing: "",
    }));
  };
  const onSaveCanvas = async (imageDownloadUrl: any) => {
    Swal.showLoading();
    let blob = await fetch(imageDownloadUrl, { method: "GET", mode: "no-cors" })
      .then((r) => r.blob())
      .then((blobFile) => {
        let file = new File([blobFile], "fileNameGoesHere", {
          type: "image/png",
        });
        var reader: any = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          var base64data = reader.result;
          const imageBlob = base64ToBlob(base64data, "image/png");
          var formData = new FormData();
          formData.append("file", imageBlob, "imagehighlight.png");
          handleFileUpload2s3(formData.get("file"), state.id)
            .then((res: any) => {
              let updatedState = {
                ...state,
                qst_image_after_drawing: res,
                qst_image: props.quest.qst_image,
              };
              onSaveQuestion(updatedState);
              setState((prev: any) => ({
                ...prev,
                qst_image_after_drawing: base64data,
              }));
              if (
                state.mode == "examMode" &&
                state.studentexam_id !== undefined &&
                state.studentexam_id != null
              ) {
                axios
                  .post(`${BASE_URL}/student/saveq.php`, updatedState)
                  .then((res: any) => {
                    Swal.close();
                    Swal.fire({
                      icon: "success",
                      text: "Question Saved Successfully",
                    }).then(() => {});
                  });
              }
            })
            .catch((err: any) => {
              Swal.fire({
                icon: "error",
                text: "Something wrong, Please check your internet and try again ",
              });
            });
        };
      });
  };
  const loadFromUrl = async (imageDownloadUrl: any) => {
    if ("" === imageDownloadUrl) {
      return;
    }
    try {
      Swal.showLoading();
      const data = await fetch(imageDownloadUrl);
      const blob = await data.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data: any = reader.result;
          var file = new Blob([base64data], { type: "text/plain" });
          var formData = new FormData();
          formData.append("file", file, "imagehighlight.txt");
          handleFileUpload2s3(formData.get("file"), state.id)
            .then((res: any) => {
              Swal.showLoading();
              if (res?.includes("https")) {
                Swal.showLoading();
                fetch(res)
                  .then((img64: any) => {
                    Swal.showLoading();
                    img64
                      .text()
                      .then((data: any) => {
                        setState((prev: any) => ({
                          ...prev,
                          qst_image: data,
                          hasChangedImgFlag: true,
                        }));
                        Swal.close();
                      })
                      .catch((err: any) => {
                        Swal.fire({
                          icon: "error",
                          text: "Image will not appear if you have problem with internet connection",
                        });
                      });
                  })
                  .catch((err) => {
                    Swal.fire({
                      icon: "error",
                      text: "Image will not appear if you have problem with internet connection",
                    });
                  });
              } else {
                Swal.close();
              }
            })
            .catch((err: any) => {
              Swal.fire({
                icon: "error",
                text: "Something wrong, Please check your internet and try again ",
              });
            });

          resolve(base64data);
          Swal.close();
        };
      });
    } catch (error) {
      Swal.close();

      //Failed to fetch
      let e: any = error;
      if (e.message === "Failed to fetch") {
        setState((prev: any) => ({
          ...prev,
          qst_image: "",
          hasChangedImgFlag: true,
        }));
        Swal.fire(
          "Error",
          "You can't use this image from this url! please choose another image from another url or upload the image directely from PC",
          "error"
        );
      }
    }
  };
  const openAddFileInputHandler = () => {
    const fileInput = document.getElementById("addFile") as HTMLInputElement;
    fileInput.click();
  };

  const addFileHandler = (e: any) => {
    Swal.showLoading();
    const file: any = e.target.files[0];
    // Reset the input
    e.target.value = "";

    if (file && file.size > 0) {
      var reader: any = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (reader.result.split(":")[1].split("/")[0] === "image") {
          setState((prev: any) => ({
            ...prev,
            qst_image: reader.result,
            hasChangedImgFlag: true,
          }));
        }
      };
    }
    const ele = document.querySelector("#imageurl")! as HTMLInputElement;
    ele.value = "";
    Swal.close();
  };

  const handleCalibration = (e: any, total: any) => {
    let calibrationArray = [...state.calibrationArray];

    let calibration_object = { total: total, text: e.target.value };
    let findIndex = calibrationArray.findIndex(
      (cal: any) => cal.total == total
    );

    if (findIndex > -1) {
      calibrationArray[findIndex] = calibration_object;
    } else {
      calibrationArray.push(calibration_object);
    }

    setState((prev: any) => ({
      ...prev,
      calibrationArray: [...calibrationArray],
    }));
  };

  return (
    // <div className="mx-5">
    <div className="" style={{ overflowY: "auto" }}>
      <div className="row rounded my-3 p-0 ll shadow bg-question">
        {state.mode == "examMode" && (
          <div className="row col-12">
            <div
              className="  pt-4 pl-4 col-4"
              style={{
                color: props.color || "#fff",
                fontSize: "28px",
                paddingLeft: "10px",
                fontWeight: "bold",
              }}
            >
              {" "}
              Q {props.index}
            </div>
            <div
              className="  p-3 col-6 d-flex justify-content-end"
              style={{
                color: props.color || "#fff",
                fontSize: "28px",
                paddingLeft: "10px",
                fontWeight: "bold",
              }}
            >
              <input type="hidden" ref={count} value={spenttime} />
              <div>
                Spent time :{" "}
                <label id="minutes">
                  {MapSecondsToTime(Math.floor(spenttime / 60))}
                </label>
                :
                <label id="seconds">
                  {spenttime > 0 ? MapSecondsToTime(+spenttime % 60) : "00"}
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="col-12 row mx-auto align-items-center bg-question rounded p-3 text-white">
          <div className="col-12 row justify-content-between">
            {state.mode == "editingMode" ? (
              <h3 className="text-shadow"> Question Setup</h3>
            ) : null}

            {/*<button
              className="btn bg-info text-white"
              onClick={stateToJsonGradingMode}
            >
              show
            </button>*/}
            <div className="d-flex flex-column">
              <div className="form-group d-flex align-items-center my-3">
                <span className="col-auto text-shadow ">Total mark :</span>
                {state.mode === "editingMode" ? (
                  <input
                    type="number"
                    min={0}
                    className="col form-control"
                    name=""
                    id=""
                    value={state.total_mark}
                    onChange={(e) => {
                      if (
                        typeof +e.target.value == "number" ||
                        e.target.value == "" ||
                        e.target.value == "."
                      ) {
                        let total_mark = +e.target.value;

                        let temp_calibration: any = [];
                        for (let index = total_mark; index > 0; index--) {
                          temp_calibration.push({ total: index, text: "" });
                        }

                        setState((prev: any) => ({
                          ...prev,
                          calibrationArray: [...temp_calibration],
                          total_mark: +total_mark,
                        }));
                      }
                    }}
                  />
                ) : state.mode === "examMode" ||
                  state.mode === "gradingModeTeacher" ||
                  state.mode === "gradingModeStudent" ? (
                  <span className="text-shadow">{state.total_mark}</span>
                ) : null}
                {state.mode === "gradingModeTeacher" ? (
                  <>
                    <span className="col-auto border-left ml-2">Score :</span>
                    <input
                      type="number"
                      min={0}
                      className="col form-control"
                      name=""
                      id=""
                      value={state.score}
                      onChange={(e) => {
                        let score = e.target.value;
                        let updatedState = { ...state, score };
                        onSaveQuestion(updatedState);

                        setState((prev: any) => ({ ...prev, score: score }));
                      }}
                    />
                  </>
                ) : state.mode === "gradingModeStudent" ? (
                  <>
                    <span className="border-left ml-2 pl-2 text-shadow">
                      Score : {state.score}
                    </span>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          {"editingMode" != state?.mode ? null : (
            <div className="col-12 mb-5 row justify-content-center align-items-center">
              <div className="bg-white w-100 text-dark rounded align-items-center p-3">
                Highlight Image
              </div>
            </div>
          )}

          <div className="col-12 mb-5 row justify-content-center align-items-center">
            {state.mode === "editingMode" ? (
              <div className="col-12 w-100 row justify-content-center align-items-center">
                <RichBox
                  onChange={(v: any) => {
                    setState((prev: any) => ({ ...prev, header: v }));
                  }}
                  onChangeTxt={(a: any) => {
                    setState((prev: any) => ({ ...prev, headertxt: a }));
                  }}
                  defaultValue={state.header}
                  height={"100%"}
                ></RichBox>
                <div className="mt-2 col-8 row justify-content-center">
                  <label className="align-self-start">Author Note </label>
                  <input
                    className="form-control align-self-stretch "
                    name=""
                    id=""
                    value={state.author_note}
                    onChange={(e) => {
                      let author_note = e.target.value;
                      setState((prev: any) => ({
                        ...prev,
                        author_note: author_note,
                      }));
                    }}
                  ></input>
                </div>
                <div className="mt-2 col-lg-8 row">
                  <button
                    className="btn bg-info text-white"
                    onClick={() => {
                      openAddFileInputHandler();
                      setState((prev: any) => ({ ...prev, qst_image: "" }));
                    }}
                  >
                    {" "}
                    upload img
                  </button>
                  <input
                    accept="image/*"
                    id="addFile"
                    multiple={false}
                    hidden={true}
                    type="file"
                    onChange={addFileHandler}
                  />
                  <label
                    className="align-self-center ml-5 mr-4 mt-1"
                    htmlFor="imageurl"
                  >
                    OR Image Url:{" "}
                  </label>
                  <input
                    id="imageurl"
                    name="imageurl"
                    type="text"
                    className="col-lg-8  form-control normal"
                    onChange={(e) => {
                      const tmp_url = e.target.value;
                      if (" " === tmp_url) {
                        e.target.value = "";
                        return;
                      }

                      loadFromUrl(tmp_url);
                      setState((prev: any) => ({
                        ...prev,
                        qst_image: tmp_url,
                      }));
                    }}
                  />

                  {state.qst_image ? (
                    <img
                      src={state.qst_image}
                      max-width="100%"
                      max-height="80%"
                      className="col-12 mt-3 rounded  mx-auto d-block"
                      alt="..."
                    ></img>
                  ) : null}

                  {state.msg !== "" ? <div>{state.msg}</div> : null}
                </div>
              </div>
            ) : state.mode === "examMode" ||
              state.mode === "gradingModeTeacher" ||
              state.mode === "gradingModeStudent" ? (
              <>
                {props.passage ? (
                  <div
                    className="bg-white w-100 text-dark rounded align-items-center p-3 mb-3"
                    dangerouslySetInnerHTML={{
                      __html: `<h4>Passage : </h4> ${props.passage.header}`,
                    }}
                  ></div>
                ) : (
                  ""
                )}
                <div
                  className="bg-white w-100 text-dark rounded align-items-center p-3"
                  dangerouslySetInnerHTML={{
                    __html: `<h5>Question : </h5> ${state.header}`,
                  }}
                ></div>
              </>
            ) : (
              <div></div>
            )}
          </div>

          {state.mode === "editingMode" ? (
            <DifficultLevel
              difficult_id={state.difficult_id}
              cognitive_id={state.cognitive_id}
              onChangeDifficult={(difficult_id: any) => {
                setState((prev: any) => ({
                  ...prev,
                  difficult_id: difficult_id,
                }));
              }}
              onChangeCognitive={(cognitive_id: any) => {
                setState((prev: any) => ({
                  ...prev,
                  cognitive_id: cognitive_id,
                }));
              }}
            />
          ) : null}

          <div className="col-12 mt-5" style={{ marginTop: "100px" }}></div>
          {state.mode === "editingMode" ? (
            <LearningStandards
              all_targets={
                state.all_targets?.length > 0
                  ? state.all_targets
                  : props.course_standards_targets
              }
              question={state}
              coursestandards={props.coursestandards}
              onChangeStanderd={(standardid: any) => {
                setState((prev: any) => ({ ...prev, standardid: standardid }));
              }}
              updateTargets={(all_targets: any) => {
                setState((prev: any) => ({
                  ...prev,
                  all_targets: all_targets,
                }));
              }}
              onChangeTargets={(learning_targets: any) => {
                setState((prev: any) => ({
                  ...prev,
                  learning_targets: learning_targets,
                }));
              }}
            ></LearningStandards>
          ) : null}
          <div className="col-12 row justify-content-center align-items-center">
            {state.mode === "examMode" ? (
              <>
                <div className="col-12 w-100 mt-3 row justify-content-center align-items-center">
                  {state.qst_image_after_drawing?.includes("https://") ? (
                    <div></div>
                  ) : (
                    <div className="">
                      <ReactPainter
                        key={state.resetCanvas}
                        width={deviceWidth < 1000 ? 300 : 700}
                        image={
                          state.qst_image_after_drawing !== "" &&
                          state.qst_image_after_drawing != null
                            ? state.qst_image_after_drawing
                            : state.qst_image
                        }
                        render={({
                          triggerSave,
                          canvas,
                          setColor,
                          setLineWidth,
                          imageDownloadUrl,
                        }) => (
                          <div>
                            <div className="m-2 row justify-content-center">
                              <div className="col-md-4">
                                <button
                                  className="pt-3 pb-4 mt-2 btn bg-info text-white btn-block"
                                  onClick={() => resetcanvasfunc()}
                                >
                                  Reset
                                </button>
                              </div>
                              <div className="col-md-4">
                                <label htmlFor="line-color">Color</label>
                                <input
                                  type="color"
                                  className="form-control"
                                  id="line-color"
                                  onChange={(e) => setColor(e.target.value)}
                                />
                              </div>
                              <div className="col-md-4">
                                <label htmlFor="line-width">Line Width</label>
                                <input
                                  type="number"
                                  id="line-width"
                                  defaultValue={5}
                                  className="form-control"
                                  onChange={(e) =>
                                    setLineWidth(Number(e.target.value))
                                  }
                                />
                              </div>
                            </div>
                            <div
                              onTouchStart={triggerSave}
                              onTouchMove={triggerSave}
                              onTouchEnd={triggerSave}
                              onMouseDown={triggerSave}
                              onMouseLeave={triggerSave}
                              onMouseMove={triggerSave}
                            >
                              {canvas}
                            </div>

                            <button
                              className="p-3 btn bg-info text-white btn-block "
                              onClick={() => {
                                onSaveCanvas(imageDownloadUrl);
                              }}
                              disabled={imageDownloadUrl ? false : true}
                            >
                              Save & submit
                            </button>
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
              </>
            ) : state.mode === "gradingModeTeacher" ||
              state.mode === "gradingModeStudent" ? (
              <div className="bg-white w-100 text-dark rounded align-items-center p-3">
                <img
                  src={state.qst_image_after_drawing}
                  className="rounded mx-auto d-block"
                  alt="..."
                ></img>
              </div>
            ) : (
              <div></div>
            )}
            {state.mode === "gradingModeTeacher" ||
            state.mode === "gradingModeStudent" ? (
              <>
                <div className="col-12 row align-items-start align-content-start mx-auto">
                  <label className="align-self-start">Feedback</label>
                  <textarea
                    className="form-control align-self-stretch "
                    name=""
                    id=""
                    value={state.feedback}
                    rows={5}
                    disabled={
                      state.mode === "gradingModeStudent" ? true : false
                    }
                    onChange={(e) => {
                      let feedback = e.target.value;
                      let updatedState = { ...state, feedback };
                      onSaveQuestion(updatedState);
                      setState((prev: any) => ({
                        ...prev,
                        feedback: feedback,
                      }));
                    }}
                  ></textarea>
                </div>

                {state.author_note != "" &&
                state.mode === "gradingModeTeacher" ? (
                  <div className="col-12 row align-items-start align-content-start mx-auto">
                    <label className="align-self-start">Author Note </label>
                    <textarea
                      className="form-control align-self-stretch "
                      name=""
                      id=""
                      value={state.author_note}
                      rows={5}
                      disabled={
                        state.mode === "gradingModeStudent" ||
                        state.mode === "gradingModeTeacher"
                          ? true
                          : false
                      }
                      onChange={(e) => {
                        let author_note = e.target.value;
                        setState((prev: any) => ({
                          ...prev,
                          author_note: author_note,
                        }));
                      }}
                    ></textarea>
                  </div>
                ) : null}
              </>
            ) : null}
          </div>

          {state.mode === "editingMode" ? (
            <div className="row col-12">
              <div className=" col-md-6 my-2">
                {" "}
                Analytical Rubrics :
                <div className="  row  col-12 ">
                  {state.calibrationArray
                    ?.sort((a: any, b: any) => b.total - a.total)
                    .map((cal: any, index: any) => {
                      let total = cal.total;
                      if (total == 1 && props.etype == "capstone") {
                        return <div></div>;
                      }
                      return (
                        <div className="col-6 my-3" key={total}>
                          <label>
                            The score will be {total}
                            {props.etype == "capstone" ? (
                              <span> ({colors[index]})</span>
                            ) : (
                              ``
                            )}{" "}
                            if :
                          </label>
                          <textarea
                            className="form-control"
                            onChange={(e: any) => {
                              handleCalibration(e, total);
                            }}
                            value={
                              state.calibrationArray?.find(
                                (cal: any) => cal.total == total
                              )?.text ?? ""
                            }
                          ></textarea>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className=" col-md-6 my-2">
                {" "}
                Holistic Rubrics :
                <div className="  row  col-12 ">
                  {
                    <div className="col-12 my-3">
                      <label></label>
                      <textarea
                        className="form-control"
                        onChange={(e: any) => {
                          let value = e.target.value;
                          let temp_calibration = state.calibration;
                          temp_calibration = {
                            Analytical: "",
                          };
                          temp_calibration["Holistic"] = value;
                          setState((prev: any) => ({
                            ...prev,
                            calibration: temp_calibration,
                          }));
                        }}
                        value={state.calibration?.Holistic}
                      ></textarea>
                    </div>
                  }
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {(state.mode == "editingMode" || state.mode == "answeringMode") && (
            <div className="text-center col-12">
              <button
                className="btn btn-warning btn-lg rounded col-3 mt-3"
                onClick={() => onSaveQuestion(state)}
              >
                {" "}
                Save
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageHighlight;
